{
	"noBackgroundDetectedError": "No background detected.",
	"noPeopleDetectedError": "No people detected.",
	"noSkyDetectedError": "No sky detected.",
	"noSubjectDetectedError": "No subject detected."
}
